module.exports = __webpack_public_path__ + "media/icons/iphone_app-ec2295bb.png";